import React, { useEffect, useState } from "react";
import { GetActivities } from "../../hooks/useServiceData";
import { ActivityTableHeadCells } from "../../constants/ActivityConstants";
import GeneralTable from "../GeneralTable";

export const ActivityTable = (props) => {
  const [activities, setActivities] = useState([]);

  const { data } = GetActivities();
  // console.log("data: ", data);

  useEffect(() => {
    let activityList = [];

    if (data?.data) {
      activityList = data?.data.map((activity) => {
        return {
          id: activity.id,
          owner_id: activity.owner_id,
          name: activity.name,
          cost: activity.cost,
          account: activity.account.number,
          isActive: activity.isActive === 1 ? "Aktiv" : "Inaktiv",
        };
      });
      setActivities(activityList);
    }
  }, [data]);

  return (
    <>
      <GeneralTable
        headCells={ActivityTableHeadCells}
        rows={activities}
        handleSelect={props.handleSelect}
      />
    </>
  );
};
